import { AppActionTypes, ApplicationActions } from '../store/application-actions';

export function onOpenDeleteDialog(sessionId: string, dispatch: React.Dispatch<ApplicationActions>): void {
  dispatch({ type: AppActionTypes.SET_CONVERSATION_TO_DELETE, payload: sessionId });
}
